import { type IImage } from '@/types/IImage';
import { NO_IMAGE_LINK_UNIVERSAL } from '../constants/imageDefaultLink';

const extractImageLink = (image: IImage): string => {
  if (image.thumbnail_100 !== null && image.thumbnail_100 !== undefined) {
    return image.thumbnail_100.link;
  }
  if (image.thumbnail_50 !== null && image.thumbnail_50 !== undefined) {
    return image.thumbnail_50.link;
  }
  if (image.thumbnail_0 !== null && image.thumbnail_0 !== undefined) {
    return image.thumbnail_0.link;
  }
  return image.link;
};

export const getImage = (image: IImage | null): string => {
  if (image !== null) {
    return extractImageLink(image);
  }
  return NO_IMAGE_LINK_UNIVERSAL;
};

/**
 * Возвращает ссылку на изображение товара с fallback'ом.
 * Сначала проверяет offerImage, если оно есть, возвращает ссылку из него.
 * Если offerImage null или undefined, проверяет productImage.
 * Если оба null/undefined, возвращает NO_IMAGE_LINK_UNIVERSAL.
 * @param offerImage - Изображение оффера (может быть null).
 * @param productImage - Изображение продукта (опционально, может быть null).
 * @returns Ссылка на изображение (string).
 */
export const getImageWithFallback = (
  offerImage: IImage | null,
  productImage?: IImage | null
): string => {
  if (offerImage !== null) {
    return extractImageLink(offerImage);
  }
  if (productImage != null) {
    return extractImageLink(productImage);
  }
  return NO_IMAGE_LINK_UNIVERSAL;
};

export interface IImageWithToggleResult {
  primaryImage: string;
  alternativeImage: string | null;
  hasAlternative: boolean;
}

export const getImageWithToggle = (
  offerImage: IImage | null,
  productImage?: IImage | null
): IImageWithToggleResult => {
  const hasOffer = offerImage !== null;
  const hasProduct = productImage != null;

  if (hasOffer) {
    return {
      primaryImage: extractImageLink(offerImage),
      alternativeImage: null,
      hasAlternative: false
    };
  }

  return {
    primaryImage: NO_IMAGE_LINK_UNIVERSAL,
    alternativeImage: hasProduct ? extractImageLink(productImage) : null,
    hasAlternative: hasProduct
  };
};
